"use client";

import styles from "./FormInput.module.scss";

export default function FormInput({
  name,
  register,
  placeholder,
  error,
  type = "text",
  className = "",
}) {
  return (
    <div className={styles.formInputWrapper}>
      <input
        name={name}
        {...register(name)}
        placeholder={placeholder}
        type={type}
        className={`${styles.inputBox} ${className}`}
      />
      {error && <p className={styles.errorMessage}>{error.message}</p>}
    </div>
  );
}
